import { faCartShopping } from '@fortawesome/free-solid-svg-icons';
import { Shop } from '.';
import { ShoppingCartPage } from './ShoppingCartPage';
import { ProductDetailsPage } from './ProductDetailsPage';
import { OrdersPage } from './OrdersPage';
import { RedirectPage } from './RedirectPage';
import { ProductListPage } from './ProductListPage';
const routes = {
    'w/:wallet_id/shop': {
        path: 'w/:wallet_id/shop',
        title: 'Shop',
        component: Shop,
        mainPage: true,
        auth: true,
        exact: true,
        showTab: true,
        icon: faCartShopping
    },
    'w/:wallet_id/shop/product/:product_id': {
        path: 'w/:wallet_id/shop/product/:product_id',
        title: 'Product',
        component: ProductDetailsPage,
        auth: true,
        exact: true,
        showTab: false,
        icon: faCartShopping
    },
    'w/:wallet_id/shop/orders/': {
        path: 'w/:wallet_id/shop/orders/',
        title: 'Orders',
        component: OrdersPage,
        auth: true,
        exact: true,
        showTab: false,
        icon: faCartShopping
    },
    'w/:wallet_id/shop/cart': {
        path: 'w/:wallet_id/shop/cart',
        title: 'Cart',
        component: ShoppingCartPage,
        auth: true,
        exact: true,
        showTab: false,
        icon: faCartShopping
    },
    'w/redirect/:scheme': {
        path: 'w/redirect/:scheme',
        title: 'Redirect',
        component: RedirectPage,
        auth: false,
    },
    'w/:wallet_id/shop/product_list': {
        path: 'w/:wallet_id/shop/product_list',
        title: 'Product List',
        component: ProductListPage,
        auth: true,
        exact: true,
        showTab: false,
        icon: faCartShopping
    },
};
export default routes;
